import React, { ReactNode } from "react";
import './border.css';
import { ItemRarity } from "../item/item-types";
import { rarityOffset } from "../item/item-utils";

export type BorderProps = {
    children?: ReactNode;
    type?: BorderType;
    rarity?: ItemRarity;
    active?: boolean;
    warning?: boolean;
};
export enum BorderType {
    Default = "default",
    Weapon = "weapon",
    Tag = "tag",
}
const Border: React.FC<BorderProps> = ({
    children,
    type = BorderType.Default,
    rarity = ItemRarity.None,
    active = true,
    warning = false,
}) => (
    <div className='pixel-border'
        style={{
            borderImage: `url('/resources/menu/border/border_${type}${active ? '' : '_off'}.png') 4 round`,
        }}
    >
        {type === BorderType.Weapon && (
            <div className='weapon-icon' >
                <img
                    src='/resources/items/type/icon_weapon.png'
                    alt='Weapon Icon'
                />
            </div>
        )}
        {warning && (
            <div className='warning-icon' >
                <img
                    src='/resources/items/type/icon_warning.png'
                    alt='Warning Icon'
                />
            </div>
        )}
        {
            rarity !== ItemRarity.None && (
                <div
                    className='rarity-icon'
                    style={
                        {
                            top: rarityOffset(rarity),
                            right: rarityOffset(rarity)
                        }
                    }
                >
                    <img src={`/resources/items/rarity/icon_rarity_${rarity}.png`} alt='Rarity Icon' />
                </div>
            )}
        {children}
    </div >
);
export default React.memo(Border);